import { render, staticRenderFns } from "./MirrorBookViewer.vue?vue&type=template&id=59702b8c&scoped=true"
import script from "./MirrorBookViewer.vue?vue&type=script&lang=ts"
export * from "./MirrorBookViewer.vue?vue&type=script&lang=ts"
import style0 from "./MirrorBookViewer.vue?vue&type=style&index=0&id=59702b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59702b8c",
  null
  
)

export default component.exports